module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_17.82545631.pdf";